import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Tag from '@/components-latest/primitives/Tag'
import { textVariants } from '@/components-latest/primitives/Text'
import { OrderStatuses } from '@/ducks/orders/orders.types'

import Styles from './OrderStatus.module.scss'

interface IOrderStatusProps {
  status: OrderStatuses
  children?: React.ReactNode
  assigned?: boolean
}

const OrderStatus: React.FC<IOrderStatusProps> = ({
  status,
  assigned,
  children
}) => {
  const { t } = useTranslation()
  const baseClassName = clsx(
    Styles.orderStatus,
    textVariants({ variant: 'nextBody', weight: 'semiBold' })
  )

  switch (status) {
    case 'DELIVERED':
    case 'COMPLETED':
      return (
        <Tag className={clsx(Styles.green, baseClassName)}>
          {children || t('orders.statuses.completed')}
        </Tag>
      )
    case 'READY':
      return assigned ? (
        <Tag className={clsx(Styles.blue, baseClassName)}>
          {children || t('orders.statuses.ready')}
        </Tag>
      ) : null
    case 'REJECTED':
      return (
        <Tag className={clsx(Styles.darkPink, baseClassName)}>
          {children || t('orders.statuses.rejected')}
        </Tag>
      )
    case 'CANCELED':
      return (
        <Tag className={clsx(Styles.lightBrown, baseClassName)}>
          {children || t('orders.statuses.canceled')}
        </Tag>
      )
    case 'RETURNED':
      return (
        <Tag className={clsx(Styles.brown, baseClassName)}>
          {children || t('orders.statuses.returned')}
        </Tag>
      )
    case 'PICKED_UP':
      return (
        <Tag className={clsx(Styles.lightblue, baseClassName)}>
          {children || t('orders.statuses.picked-up')}
        </Tag>
      )
      case 'ORDER_TIMEOUT':
      return (
        <Tag className={clsx(Styles.lightblue, baseClassName)}>
          {children || t('orders.statuses.timed-out')}
        </Tag>
      )
    default:
      return <Tag className={clsx(baseClassName)}>{children}</Tag>
    // case 'unpaid':
    //   return (
    //     <Tag className={clsx(Styles.red, baseClassName)}>
    //       {children || t('orders.statuses.unpaid')}
    //     </Tag>
    //   )

    case 'ACCEPTED':
            return assigned ? (
              <Tag className={clsx(Styles.blue, baseClassName)}>
                {children || t('orders.statuses.accepted')}
              </Tag>
            ) : null
  }
}

export default OrderStatus
